export default __webpack_public_path__ + "static/media/login.fe92a7a6.png";